module.exports = __webpack_public_path__ + "img/google_maps_header.5bd72fb6.jpg";